import React, { Component } from "react";
import {
  TouchableOpacity,
  Image,
  View,
  StyleSheet,
  TouchableNativeFeedback,
} from "react-native";
import colors from "@constants/color";
import Text from "@components/AppText";
import metrics from "@constants/metrics";

const Radio = ({ value, item }) => {
  const checkedImage = require("../assets/svg/WithdrawMoney/Checked.webp");
  const uncheckedImage = require("../assets/svg/WithdrawMoney/UnChecked.webp");

  return value === item.key ? (
    <Image source={checkedImage} style={{ height: 25, width: 25 }} />
  ) : (
    <Image source={uncheckedImage} style={{ height: 25, width: 25 }} />
  );
};

export default class RadioButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.active ? this.props.active : null,
    };
  }

  onPressButton = (item) => {
    const { setSelectedOption = () => {} } = this.props || {};
    this.setState({ value: item && item.key }, () =>
      setSelectedOption(item && item.key),
    );
  };

  static getDerivedStateFromProps(props, state) {
    if (props.default && props.default !== state.value) {
      return {
        value: props.default,
      };
    }
    return state.value;
  }

  render() {
    const {
      radioOptions = [],
      wrapperStyles = {},
      showRadioInLast = false,
      hindiText = false,
      labelColor = "",
      radioColor = "",
      buttonOptionsCustom = {},
      buttonContainerBorder = {},
      radionButtonContainerStyle = {},
      buttonContainerStyle = {},
    } = this.props;

    const { value } = this.state;

    const textProps = {
      mukta: hindiText,
    };

    return (
      <View style={radionButtonContainerStyle}>
        {Array.isArray(radioOptions) && radioOptions.length
          ? radioOptions?.map((item, i) => {
              return (
                <TouchableOpacity
                  key={item?.key}
                  style={[
                    i !== radioOptions.length - 1
                      ? [styles.buttonContainerBorder, buttonContainerBorder]
                      : null,
                    { ...buttonContainerStyle },
                  ]}
                  onPress={() => this.onPressButton(item)}
                  background={TouchableNativeFeedback.Ripple(
                    "rgba(0, 0, 0, 0.05)",
                  )}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginRight: 20,
                    }}
                  >
                    <View
                      style={[
                        styles.buttonContainer,
                        wrapperStyles,
                        {
                          ...(i === radioOptions.length - 1
                            ? { borderBottomColor: "transparent" }
                            : {}),
                        },
                        {
                          width: item.rightIcon ? "90%" : "100%",
                          // paddingHorizontal: 5,
                        },
                      ]}
                    >
                      <View />
                      {!showRadioInLast ? (
                        <Radio
                          radioColor={radioColor}
                          value={value}
                          item={item}
                        />
                      ) : null}
                      <View>
                        <Text
                          fontType="content2"
                          style={[
                            styles.buttonOption,
                            buttonOptionsCustom,
                            {
                              color:
                                value === item?.key
                                  ? "#000"
                                  : labelColor
                                    ? labelColor
                                    : colors.lightBlack,
                            },
                            buttonOptionsCustom
                              ? {
                                  fontSize:
                                    this.props?.fromSelfDeactivation ||
                                    this.props?.fromClTask
                                      ? 16
                                      : 14,
                                  fontFamily:
                                    this.props?.fromSelfDeactivation ||
                                    this.props?.fromClTask
                                      ? value === item?.key
                                        ? "NotoSansDevanagari-SemiBold"
                                        : "NotoSansDevanagari-Regular"
                                      : value === item?.key
                                        ? "NotoSansDevanagari-SemiBold"
                                        : "NotoSansDevanagari-Regular",
                                }
                              : {},
                          ]}
                          {...textProps}
                        >
                          {item?.text || item?.label || item?.value}
                        </Text>
                        {Boolean(item?.subTitle) && (
                          <Text style={{ marginLeft: 16 }} fontType="content3">
                            {item?.subTitle}
                          </Text>
                        )}
                      </View>
                      {showRadioInLast ? (
                        <Radio
                          radioColor={radioColor}
                          value={value}
                          item={item}
                        />
                      ) : null}
                    </View>
                    {item?.rightIcon ? <View>{item?.rightIcon}</View> : null}
                  </View>
                </TouchableOpacity>
              );
            })
          : null}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  buttonContainer: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    padding: metrics.baseGutter,
  },
  buttonContainerBorder: {
    borderBottomWidth: 1,
    borderBottomColor: "rgba(0,0,0,0.1)",
  },
  buttonOption: {
    marginLeft: 16,
    color: colors.lightBlack,
  },
  circle: {
    height: 20,
    width: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: colors.lightBlack,
    alignItems: "center",
    justifyContent: "center",
  },
  checkedCircle: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: colors.lightBlack,
  },
});
